module.exports = __webpack_public_path__ + "assets/img/c8085c9847aad52fa14c39e289ae1da3.svg";